import { useEffect } from 'react';
import { toast } from 'react-toastify';

const TOAST_ID = 'server-status';

const ServerStatusMonitor = () => {
  useEffect(() => {
    const onDown = () => {
      if (!toast.isActive(TOAST_ID)) {
        toast.error('Server is currently unreachable. Please wait or try again shortly.', {
          toastId: TOAST_ID,
          autoClose: false,
          closeOnClick: false,
          draggable: false,
        });
      }
    };

    const onUp = () => toast.dismiss(TOAST_ID);

    window.addEventListener('server:down', onDown);
    window.addEventListener('server:up',   onUp);
    return () => {
      window.removeEventListener('server:down', onDown);
      window.removeEventListener('server:up',   onUp);
    };
  }, []);

  return null;
};

export default ServerStatusMonitor;
